// 导出所有的接口
import common from './modules/common';
import interfacePlatform from './modules/interfacePlatform';
import orderCenter from './modules/orderCenter';
import promotionCenter from './modules/promotionCenter';
import commodityCenter from './modules/commodityCenter';
import inventoryCenter from './modules/inventoryCenter';
import strategyPlatform from './modules/strategyPlatform';
import organizationCenter from './modules/organizationCenter';
import financeCenter from './modules/financeCenter';
import memberCenter from './modules/memberCenter';
import reportCenter from './modules/reportCenter';
import systemConfig from './modules/systemConfig';
import basicData from './modules/basicData';
import userCenter from './modules/userCenter';

const allServices = {
  common, // 公共
  interfacePlatform, // 接口平台
  orderCenter, // 订单中心
  promotionCenter, // 促销中心
  commodityCenter, // 商品中心
  inventoryCenter, // 库存中心
  strategyPlatform, // 策略平台
  organizationCenter, // 组织中心
  financeCenter, // 财务中心
  memberCenter, // 会员中心
  reportCenter, // 报表中心
  systemConfig, // 系统配置
  basicData, // 基础数据
  userCenter,
};

export default allServices;